import * as React from 'react';
import { createContext, composeEventHandlers } from '../../utils';
import { useDisclosure } from './useDisclosure';
import { jsx as _jsx } from "react/jsx-runtime";
const [DisclosureProvider, useDisclosureContext] = createContext('Disclosure');
function Root({
  id,
  open: openProp,
  defaultOpen,
  disabled,
  onOpenChange,
  children
}) {
  const {
    open,
    contentId,
    toggle
  } = useDisclosure({
    id,
    open: openProp,
    defaultOpen,
    onOpenChange
  });
  return /*#__PURE__*/_jsx(DisclosureProvider, {
    contentId: contentId,
    open: open,
    disabled: disabled,
    toggle: toggle,
    children: children
  });
}
function Trigger({
  as: Comp = 'button',
  children,
  onClick,
  ...extraProps
}) {
  const {
    contentId,
    open,
    disabled,
    toggle
  } = useDisclosureContext('DisclosureTrigger');
  return /*#__PURE__*/_jsx(Comp, {
    type: "button",
    disabled: disabled,
    "aria-expanded": open,
    "aria-controls": contentId,
    "data-state": getState(open),
    onClick: composeEventHandlers(onClick, toggle),
    ...extraProps,
    children: children
  });
}
function Content({
  as: Comp = 'div',
  children,
  ...extraProps
}) {
  const {
    open,
    contentId,
    disabled
  } = useDisclosureContext('DisclosureContent');
  return /*#__PURE__*/_jsx(Comp, {
    id: contentId,
    hidden: !open,
    "data-state": getState(open),
    "data-disabled": disabled ? '' : undefined,
    ...extraProps,
    children: children
  });
}
function getState(open) {
  return open ? 'open' : 'closed';
}
Root.displayName = 'Disclosure';
Trigger.displayName = 'DisclosureTrigger';
Content.displayName = 'DisclosureContent';
export { Root as Disclosure, Trigger as DisclosureTrigger, Content as DisclosureContent };